// External imports
import { createFileRoute } from "@tanstack/react-router";

// Internal imports
import LandingPage from "@/features/public/pages/landing";

export const Route = createFileRoute("/(public)/_public/")({
  component: () => <LandingPage />,

  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Error Loading Landing Page</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});
